<template lang="pug">
  div#navegador
    v-app-bar( elevate-on-scroll  fixed height=100 style='z-index: 30')
      v-container(fluid)
        v-col
          v-row(align='center').py-5
            v-btn( text :to='{name: "inicio"}' color='transparent' elevation='0' )
              v-img( :src='navegador.logo' height=50 width='180' contain )
            v-spacer
            
            template(v-for='{texto, vinculo}, i of navegador.menu' )
              v-btn.d-none.d-lg-flex( :to='{name: vinculo}' text active-class='activo').azul--text.font-weight-bold.pl-1.pr-0.text-left.icono-international.hover.boton-menu 
                span {{texto}}
            template( v-for='{icono, vinculo}, i of navegador.redes_sociales')
              v-card.d-none.d-lg-flex( fab x-small elevation=0 :href='vinculo'  target='_blank' ).ml-3.boton-social
                v-img(small color='white' width=20 height=20 :src='icono')   
            v-btn.d-lg-none( icon @click='drawer=true') 
              v-icon fa-bars
               
              
    v-navigation-drawer( v-model="drawer" fixed temporary style='z-index: 40')
      v-row
        v-col
          template(v-for='{texto, vinculo}, i of navegador.menu' )
            v-btn( block :to='{name: vinculo}' text active-class='activo').py-10.azul--text.font-weight-bold.text-left.mb-5.boton-menu
              span.icono-international.hover.pl-4.pt-2 {{texto}}
          v-row(justify='center').mt-8
            template( v-for='{icono, vinculo}, i of navegador.redes_sociales')
              v-card( elevation=0 :href='vinculo' target='_blank' ).ml-3.px-0
                v-img(small color='white' width=30 height=30 :src='icono') 


</template>
<script>

export default {
  data: ()=>({  
    drawer : false
  }),
  computed: {
    navegador() {
      return this.$contenido.navegador || {}
    },
  
  }
}
</script>
<style lang="sass">
.v-app-bar--is-scrolled
  background-color: white
.v-app-bar--hide-shadow
  background-color: white!important

 
.boton-social
  border-radius: 5px!important
.boton-menu
  .v-btn__content
    padding: 15px 20px
    max-width: 140px
    white-space: normal
    text-align: left
    
</style>